export const currentlyItems = [
  {
    id: 'searchstory',
    title: 'AI × Self',
    subtitle: 'Ongoing project',
    route: '/projects',
    anchor: 'searchstory',
    context: 'Henry is developing AI × Self, a personal archive that lets visitors connect his work, ideas and experiences through their own questions. Each View composes a perspective with original sources. The Gallery brings these readings together as exhibitions to explore and share.'
  },
  {
    id: 'pwc',
    title: 'PwC',
    subtitle: 'Cloud, Data & AI',
    route: '/experience',
    anchor: 'work-pwc',
    context: 'Henry is currently a Cloud, Data & AI consulting intern at PwC in Hong Kong, where he designs and evaluates AI systems for financial services and public sector work.'
  },
  {
    id: 'location',
    title: 'Hong Kong',
    subtitle: 'Current location',
    route: '/travels',
    anchor: 'hong-kong',
    context: 'Henry is currently based in Hong Kong.'
  },
  {
    id: 'structure-settles-thought',
    title: 'Early Epistemic Settlement',
    subtitle: 'Research in progress',
    route: '/research',
    anchor: 'structure-settles-thought',
    context: 'Henry is currently developing Early Epistemic Settlement in AI-Assisted Writing, a research project about how an AI-supplied structure can meet a passage’s current demands while the writer’s own work towards a resolution remains unfinished, and how this changes what they can defend or develop later.'
  },
  {
    id: 'projection-of-thought',
    title: 'Projection of Thought',
    subtitle: 'Recent fragment',
    route: '/fragments',
    anchor: 'the-projection-of-thought',
    context: 'Henry recently wrote The Projection of Thought, a fragment exploring how expression projects layered and moving thought onto the flatter surface of language, which then guides later thinking.'
  }
];

export const currentlyChunk = {
  title: 'What Henry is currently doing',
  body: currentlyItems.map((item) => item.context).join(' ')
};
